import type { FunctionComponent } from "react";

import { ClientSideSuspense } from "~/components/common/client-side-suspense";

import { HeroArticlesContent } from "./hero-articles-content";
import { Container } from "./styles";

export const HeroArticles: FunctionComponent = () => (
  <Container>
    <ClientSideSuspense>
      <HeroArticlesContent queueName="posties_promotion" />
    </ClientSideSuspense>
  </Container>
);

HeroArticles.displayName = "HeroArticles";
